import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { NavigationProvider } from '@/contexts/NavigationContext';
import { ModalProvider } from '@/contexts/ModalContext';
import { FeatureFlagProvider } from '@/contexts/FeatureFlagContext';

/**
 * Implements theme management, navigation tracking, feature flags, and provides the root layout for all pages.
 */
const App: React.FC = () => {
    return (
        <FeatureFlagProvider>
            <ThemeProvider>
                <NavigationProvider>
                    <ModalProvider>
                        <Outlet />
                    </ModalProvider>
                </NavigationProvider>
            </ThemeProvider>
        </FeatureFlagProvider>
    );
};

export default App;